import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { ConfigStateService } from '@abp/ng.core';
import { ConfigurationSettingsDto } from './models';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationSettingsService {
  private apiBase = environment.apis.default.url;

  constructor(
    private http: HttpClient,
    private configStateService: ConfigStateService,
    private config: ConfigStateService
  ) {}

  getProductCredentialSettings(): Observable<ConfigurationSettingsDto[]> {
    return this.http.get<ConfigurationSettingsDto[]>(
      `/api/app/configuration-settings/host-settings/product-credential-settings`
    );
  }

  saveSetting(settings: ConfigurationSettingsDto[]): Observable<any> {
    let tenantId = this.config.getDeep(['currentUser', 'tenantId']);
    let isHost = tenantId == null;
    const address = isHost
      ? `/api/app/configuration-settings/host-settings/settings`
      : `/api/app/configuration-settings/settings`;

    return this.http.post(address, settings).pipe(
      map(
        response => {
          this.configStateService.refreshAppState().subscribe();

          return response;
        },
        catchError(() => {
          return null;
        })
      )
    ) as Observable<any>;
  }
}
